import React from 'react';
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@material-ui/core';
import ViewIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import TextTooltip from '../../../components/TextTooltip';

const LabelsTable = ({
  classes = {},
  loading,
  rows = [],
  onDeleteLabelSamples = () => {},
  onViewLabelSamples = () => {},
  onRelabelSample = () => {},
  lookupTable = {},
}) => {
  if (!rows.length) {
    return null;
  }
  return (
    <Paper className={classes.paper}>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader aria-label="sticky table">
          <TableBody>
            {rows.map(({ label, samplesSize }) => {
              return (
                <TableRow hover tabIndex={-1} key={label}>
                  <TableCell className={classes.bold}>
                    <TextTooltip
                      text={
                        label in lookupTable
                          ? `${lookupTable[label]?.translated_name} (${lookupTable[label]?.human_readable_name})`
                          : label
                      }
                      maxLength={20}
                    />
                  </TableCell>
                  <TableCell align="center" className={classes.number}>
                    {samplesSize}
                  </TableCell>
                  <TableCell align="right">
                    <Grid container justifyContent="flex-end" spacing={2}>
                      <Grid item>
                        <Button
                          size="small"
                          disabled={loading}
                          className={classes.blueButton}
                          endIcon={<ViewIcon />}
                          variant="contained"
                          disableElevation
                          onClick={() => onViewLabelSamples(label)}
                        >
                          View
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          size="small"
                          disabled={loading}
                          className={classes.darkBlueButton}
                          endIcon={<EditIcon />}
                          variant="contained"
                          disableElevation
                          onClick={() => onRelabelSample(label)}
                        >
                          Re-Label
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          size="small"
                          disabled={loading}
                          className={classes.redButton}
                          endIcon={<DeleteIcon />}
                          variant="contained"
                          disableElevation
                          onClick={() => onDeleteLabelSamples(label)}
                        >
                          Delete
                        </Button>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default LabelsTable;
